module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/qr_iphone-03927f321005be2dbad2585eb2efeb7d.png";